<template>
  <a-modal
    v-model="visible"
    title="素材系列视频标签"
    @ok="handleOK"
    :footer="showSettings ? false : undefined"
  >
    <a-form
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 17 }"
      labelAlign="left"
    >
      <a-form-item label="大类" class="link-material-form-item">
        <a-select v-model="type">
          <a-select-option :value="1">公司</a-select-option>
          <a-select-option :value="2">产品</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="子分类" class="link-material-form-item">
        <a-cascader
          :options="options"
          v-model="values"
          placeholder="选择一个子分类。"
          allowClear
        />
      </a-form-item>
      <a-form-item
        :label="usedLabel"
        class="link-material-form-item"
        v-if="linkType"
        extra="请输入一个位于 1 和 7 之间的数字。"
      >
        <a-input-number
          v-model="linkValue"
          :min="0"
          :max="6"
          class="setting-input"
          :formatter="displayValue"
          :parser="parseValue"
        />
      </a-form-item>
      <a-form-item
        label="标签中顺序"
        v-if="values && values.length"
        class="link-material-form-item"
        :extra="
          processType === 'manual'
            ? `请输入一个位于 1 和 ${maxOrder} 之间的数字。`
            : ''
        "
      >
        <a-input-group compact>
          <a-select v-model="processType" style="width: 90px">
            <a-select-option value="auto">自动</a-select-option>
            <a-select-option value="random" :disabled="linkType === 'process'">
              随机
            </a-select-option>
            <a-select-option value="manual">手动</a-select-option>
          </a-select>
          <a-input-number
            v-model="process"
            :min="1"
            :max="maxOrder"
            :disabled="processType !== 'manual'"
            class="setting-input"
          />
        </a-input-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue';
import { mapGetters, mapState } from 'vuex';

function convertOptions(data) {
  return data.map(item => ({
    value: item.material_label_id,
    label: item.name,
    children: item.lower
      ? convertOptions(item.lower)
      : null
  }));
}

export default {
  data() {
    return {
      values: [],
      type: 1,
      process: 0,
      processType: 'auto',
      linkValue: undefined,
      showSettings: false
    }
  },
  computed: {
    ...mapGetters(['selectedEffect', 'activeFragment']),
    ...mapState(['effects']),
    visible: {
      get() {
        return this.$store.state.videoSeriesTagVisible;
      },
      set(value) {
        this.$store.commit('handleVideoSeriesTagVisible', value);
      }
    },
    options() {
      return convertOptions(this.tagData);
    },
    linkType() {
      if (this.values && this.values.length) {
        if (this.type === 2) {
          return 'product';
        }
        if (this.lastValue === '219' || this.lastValue === '213') {
          return 'process';
        }
      }

      return null;
    },
    tagData() {
      return this.$store.state.videoSeriesTagData[this.type].lower || [];
    },
    lastValue() {
      return this.values[this.values.length - 1];
    },
    maxOrder() {
      if (this.linkType === 'process') {
        return 4;
      }
      return 6;
    },
    usedLabel() {
      switch (this.linkType) {
        case 'product':
          return '产品关联';
        case 'process':
          return this.lastValue === '219' ? '质检关联' : '生产工序关联';
      }
      return '';
    }
  },
  methods: {
    handleOK() {
      console.log(this.values);
      if (!this.values.length) {
        message.error('请选择系列视频标签。');
        return;
      }
      const tagParams = {};
      switch (this.processType) {
        case 'auto':
          tagParams.process = 0;
          break;
        case 'random':
          tagParams.process = -1;
          break;
        default:
          tagParams.process = +this.process;
      }
      if (this.linkType) {
        if (this.linkValue === undefined) {
          message.error('请选择一个关联产品。');
          return;
        }
        tagParams.type = this.linkType;
        tagParams.link = this.linkValue;
      }

      this.$set(
        this.selectedEffect,
        'videoSeriesTags',
        [this.type].concat(this.values)
      );
      this.$set(this.selectedEffect, 'videoSeriesTagParams', tagParams);

      this.$store.dispatch('cleanupTags');
      message.info('标签编辑成功。');
      console.log(this.selectedEffect);
      this.visible = false;
    },
    displayValue(v) {
      if (typeof v === 'undefined' || v === '') {
        return '';
      }
      return +v + 1;
    },
    parseValue(v) {
      if (typeof v === 'undefined' || v === '') {
        return '';
      }

      return v - 1;
    }
  },
  watch: {
    type() {
      this.values = [];
    },
    linkType() {
      this.linkValue = this.linkType ? 0 : undefined;
    },
    visible(val) {
      if (val && this.selectedEffect) {
        this.showSettings = false;
        const { videoSeriesTags, videoSeriesTagParams } = this.selectedEffect;
        if (videoSeriesTags) {
          this.type = videoSeriesTags[0];
          this.$nextTick(() => {
            this.values = videoSeriesTags.slice(1);
            this.$nextTick(() => { // after execution of the watchers
              if (videoSeriesTagParams) {
                if (videoSeriesTagParams.type) {
                  this.linkValue = videoSeriesTagParams.link;
                }
                this.process = 1;
                switch (videoSeriesTagParams.process || 0) {
                  case -1:
                    this.processType = 'random';
                    break;
                  case 0:
                    this.processType = 'auto';
                    break;
                  default:
                    this.processType = 'manual';
                    this.process = +videoSeriesTagParams.process;
                }
              }
            });
          });
        } else {
          this.type = 1;
          this.values = [];
        }

        // reset em first
        this.processType = 'auto';
        this.process = 1;
      }
    },
    lastValue() {
      this.processType = 'auto';
      this.process = 1;
    }
  }
}
</script>